import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll to top on route change (ignore hash-only changes)
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
